// extracted by mini-css-extract-plugin
export default {"error":"Text_error__p7ZiO"};